// 收件匣（notify）來的警報用事件本身的顯示名（第七輪 R7-P0-1、B7-01）：
// notify 的內文是粗分類的範本（`security.alarm.tamper` 一律寫「設備被拆除或遮擋」），同一則警報在清單、詳細叫「影像訊號中斷」。
// 警報卡、細條、鈴鐺一律用 eventName(事件 key)——跟清單、詳細、總覽、搜尋同一個函式；事件還沒讀到前先用 notify 的內文。
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { fetchEvent } from './eventLookup';
import { eventName } from './eventName';
import { useAlarmStates } from './alarmStates';
import { useScope } from './scope';

export function useEventWhat(homeId: string | undefined, eventId: string | undefined, fallback: string): string {
  const { t } = useTranslation();
  const { openList, apiOf } = useAlarmStates();
  const { homes } = useScope();
  const fromList = eventId ? openList.find((a) => a.event_id === eventId && a.home_id === homeId) : undefined;
  const api = homeId ? (homes.find((h) => h.home_id === homeId)?.endpoints.api ?? apiOf(homeId)) : undefined;
  const q = useQuery({
    queryKey: ['event-what', homeId, eventId],
    queryFn: () => fetchEvent(api!, homeId!, eventId!),
    enabled: !!api && !!homeId && !!eventId && !eventId.startsWith('inbox:') && !fromList,
    staleTime: Infinity,
    gcTime: 30 * 60_000,
    retry: false,
  });
  if (fromList) return eventName(t, fromList.key, fromList.class);
  const ev = q.data;
  if (ev && typeof ev.key === 'string' && ev.key) return eventName(t, ev.key, ev.class ?? undefined, ev.fields);
  return fallback;
}

/** 元件版（清單裡每一列各自呼叫 hook 用）。 */
export function EventWhat({ homeId, eventId, fallback }: { homeId?: string; eventId?: string; fallback: string }) {
  return <>{useEventWhat(homeId, eventId, fallback)}</>;
}
